import { useQuery } from "@rocicorp/zero/react";
import { createFileRoute, Link } from "@tanstack/react-router";

import { Icon, IconName } from "@/components/ui/icon-picker";
import {
  SectionMenuChevron,
  SectionMenuContent,
  SectionMenuHeader,
  SectionMenuIcon,
  SectionMenuItem,
} from "@/components/ui/section-menu";
import { useCurrentWorkspace } from "@/features/workspaces/store/workspace.store";
import { useZero } from "@/hooks/use-zero";

export const Route = createFileRoute("/_app/w/$slug/settings/")({
  component: RouteComponent,
});

function RouteComponent() {
  const workspaceId = useCurrentWorkspace((w) => w.id);

  const zero = useZero();
  const [boards] = useQuery(
    zero.query.boards.where("workspaceId", workspaceId).related("members"),
  );
  return (
    <>
      <SectionMenuHeader>Manage boards</SectionMenuHeader>
      <SectionMenuContent>
        {boards.map((board) => {
          const renderDescription = () => {
            switch (board.visibility) {
              case "private":
                return `${board.members.length} members`;
              case "workspace":
                return "Visible to all workspace members";
            }
          };
          return (
            <SectionMenuItem
              asChild
              left={
                <SectionMenuIcon
                  icon={
                    <Icon name={board.icon as IconName} className="size-5" />
                  }
                />
              }
              right={<SectionMenuChevron />}
              description={renderDescription()}
            >
              <Link
                from={Route.fullPath}
                to="./boards/$boardId"
                params={{ boardId: board.id }}
              >
                {board.name}
              </Link>
            </SectionMenuItem>
          );
        })}
      </SectionMenuContent>
    </>
  );
}
